export default __webpack_public_path__ + "static/media/reserva-salas-reunioes.fefa890e.svg";